import { memo } from 'react';

function BeneficiariesIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.1102 6.11111C13.1102 7.82933 11.7174 9.22222 9.99913 9.22222C8.28091 9.22222 6.88802 7.82933 6.88802 6.11111C6.88802 4.39289 8.28091 3 9.99913 3C11.7174 3 13.1102 4.39289 13.1102 6.11111Z"
        stroke="#6B7280"
        strokeWidth="1.67"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.99913 11.5556C6.99225 11.5556 4.55469 13.9931 4.55469 17H15.4436C15.4436 13.9931 13.006 11.5556 9.99913 11.5556Z"
        stroke="#6B7280"
        strokeWidth="1.67"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default memo(BeneficiariesIcon);
